import { render } from "./NewsItemSummary.vue?vue&type=template&id=55edde1a&scoped=true"
import script from "./NewsItemSummary.vue?vue&type=script&lang=js"
export * from "./NewsItemSummary.vue?vue&type=script&lang=js"

import "./NewsItemSummary.vue?vue&type=style&index=0&id=55edde1a&scoped=true&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55edde1a"]])

export default __exports__